export var BusinessUpdateType;
(function (BusinessUpdateType) {
    BusinessUpdateType["Product"] = "PRODUCT";
})(BusinessUpdateType || (BusinessUpdateType = {}));
//# sourceMappingURL=BusinessUpdateType.js.map